enum PredefinedFavoritePlacesEnum {
	HOUSE = 'Casa',
	WORK = 'Trabalho',
	BILLING = 'Cobrança',
	OTHER = 'Outro',
}

enum PrincipalFavoritePlaceEnum {
	YES = 'S',
	NO = 'N',
}

type FavoritePlace = {
	cdBeneficiarioEnderecoFavorito: number;
	sequence?: number;
	type?: number;
	nmLocal: PredefinedFavoritePlacesEnum | string;
	nmLogradouro: string;
	nuEndereco: number;
	nmBairro: string;
	nmCidade: string;
	nmUf: string;
	nuCep: string;
	flPrincipal: PrincipalFavoritePlaceEnum;
	cdLatitude: string;
	cdLongitude: string;
	dsComplemento?: string;
};

type FavoritePlaceResponse = FavoritePlace[];

type FavoritePlaceParams = {
	signal?: AbortSignal;
	isHolder?: boolean;
};

interface GetFavoritePlaces {
	get: (params: FavoritePlaceParams) => Promise<FavoritePlaceResponse>;
}

export type {FavoritePlace, FavoritePlaceResponse, FavoritePlaceParams, GetFavoritePlaces};

export {PredefinedFavoritePlacesEnum, PrincipalFavoritePlaceEnum};
